'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpMqBreakpoints = require('rp-mq-breakpoints');

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var navigationSelector = '.rn-navigation.rn-wrapper';

function calcTopShift() {
    var nav = $(navigationSelector);
    return Array.prototype.reduce.call(nav, function (sum, menu) {
        return sum + $(menu).height();
    }, 0);
}

function onBreakpointChange(e) {
    if (e.detail.breakpoint.code === 'xw') {
        setTopShift();
        window.removeEventListener('rpBreakpointsSwitch', onBreakpointChange);
    }
}

function setTopShift() {
    var styleEl = document.createElement('style');
    document.head.appendChild(styleEl);

    var shiftSize = calcTopShift();
    var rule = '@media (min-width: 1278px) {\n        .ui-advertising__skinsWrp_secNav .ui-advertising_position40,\n        .ui-advertising__skinsWrp_secNav .ui-advertising_position41 {\n            top: -' + shiftSize + 'px!important;\n        }}';

    styleEl.sheet.insertRule(rule, styleEl.sheet.cssRules.length);
}

function initAdvertisingStyles() {
    if (_rpMqBreakpoints2.default.current().code === 'xw') {
        setTopShift();
        return;
    }
    window.addEventListener('rpBreakpointsSwitch', onBreakpointChange);
}

exports.default = initAdvertisingStyles;


//////////////////
// WEBPACK FOOTER
// ./public/js/advertisingStyles.js
// module id = 625
// module chunks = 0